import * as api from 'App/api/contentItems'
import * as itemsActions from 'App/modules/items/items'
import { uploadFile } from 'App/services/FileUploadService'
// eslint-disable-next-line camelcase
import { file_placeholder } from 'common/images/remote/urls.json'
import { ITEM_SOURCES } from 'shared/constants'
import omit from 'lodash/omit'
import get from 'lodash/get'

export const FETCH_CONTENT_ITEMS_FIRST_PAGE_SUCCESS = 'contentItems/FETCH_CONTENT_ITEMS_FIRST_PAGE_SUCCESS'
export const FETCH_CONTENT_ITEMS_NEXT_PAGE_SUCCESS = 'contentItems/FETCH_CONTENT_ITEMS_NEXT_PAGE_SUCCESS'
export const CREATE_CONTENT_ITEM_SUCCESS = 'contentItems/CREATE_CONTENT_ITEM_SUCCESS'
export const CREATE_FILE_CONTENT_ITEM = 'contentItems/CREATE_FILE_CONTENT_ITEM'
export const CREATE_FILE_CONTENT_ITEM_SUCCESS = 'contentItems/CREATE_FILE_CONTENT_ITEM_SUCCESS'
export const CREATE_FILE_CONTENT_ITEM_ERROR = 'contentItems/CREATE_FILE_CONTENT_ITEM_ERROR'
export const FETCH_CONTENT_ITEM_IMAGE_SUCCESS = 'contentItems/FETCH_CONTENT_ITEM_IMAGE_SUCCESS'
export const FETCH_ITEM_IMAGE_SUCCESS = 'contentItems/FETCH_ITEM_IMAGE_SUCCESS'
export const UPDATE_CONTENT_ITEM = 'contentItems/UPDATE_CONTENT_ITEM'
export const UPDATE_CONTENT_ITEM_SUCCESS = 'contentItems/UPDATE_CONTENT_ITEM_SUCCESS'
export const ARCHIVE_CONTENT_ITEM = 'contentItems/ARCHIVE_CONTENT_ITEM'
export const ARCHIVE_CONTENT_ITEM_SUCCESS = 'contentItems/ARCHIVE_CONTENT_ITEM_SUCCESS'
export const UNARCHIVE_CONTENT_ITEM = 'contentItems/UNARCHIVE_CONTENT_ITEM'
export const UNARCHIVE_CONTENT_ITEM_SUCCESS = 'contentItems/UNARCHIVE_CONTENT_ITEM_SUCCESS'
export const UPDATE_ARTICLE_ITEM = 'contentItems/UPDATE_ARTICLE_ITEM'

export function fetchItems (page, activeFilters = {}, sort = {}) {
  const actionType = (page === 1
    ? FETCH_CONTENT_ITEMS_FIRST_PAGE_SUCCESS
    : FETCH_CONTENT_ITEMS_NEXT_PAGE_SUCCESS
  )

  return (dispatch, getState) => {
    const organizationId = getState().user.organization.id

    return api.fetchContentItems(
      organizationId,
      {
        page: page || 1,
        activeFilters,
        sort
      }
    ).then(contentItems => {
      dispatch({
        type: actionType,
        ...contentItems
      })

      return contentItems
    })
  }
}

export function createItem (params) {
  return dispatch => {
    return api.createContentItem({ ...params, ...itemsActions.getAvailabilityParams(params) })
      .then(item => {
        dispatch({
          type: CREATE_CONTENT_ITEM_SUCCESS,
          item,
          trackingParams: {
            content_item_id: item.id,
            ...params
          }
        })

        return item
      })
  }
}

// poor solution until push notifications will be implemented
const MAX_RETRIES = 36
export function fetchItemUntilImagePresent (item, retry = 1) {
  return (dispatch) => {
    if (retry > MAX_RETRIES) {
      return
    }

    return api.fetchContentItem(item.id)
      .then(item => {
        // eslint-disable-next-line camelcase
        if (item.image.url === file_placeholder) {
          setTimeout(() => {
            fetchItemUntilImagePresent(item, retry + 1)(dispatch)
          }, 5000)
        } else {
          dispatch({
            type: FETCH_CONTENT_ITEM_IMAGE_SUCCESS,
            contentItemId: item.id,
            image: item.image
          })
        }
      })
  }
}

function createFileItem (file, params) {
  return uploadFile(file, { detectDuplicates: true, organizationId: params.organization_id })
    .then((result) => {
      const fileParams = {
        ...params,
        file_id: result.file_id,
        storage_provider_id: result.file_provider_type,
        file_meta: result.file_meta
      }

      return api.createContentItem(fileParams)
    })
}

export function createBoxItem (file, params) {
  const fileParams = {
    ...params,
    file_id: file.id
  }

  return api.createContentItem(fileParams)
}

export function createFileItems (params) {
  return (dispatch, getState) => {
    const action = params.item_source === ITEM_SOURCES.file ? createFileItem : createBoxItem

    return params.files.map((file) => {
      const fileParams = {
        ...params,
        title: file.name,
        file_name: file.name,
        image: {
          // eslint-disable-next-line camelcase
          url: file_placeholder,
          fit: 'cover'
        }
      }

      dispatch({
        type: CREATE_FILE_CONTENT_ITEM,
        fileParams
      })

      return action(file, fileParams)
        .then(item => {
          dispatch({
            type: CREATE_FILE_CONTENT_ITEM_SUCCESS,
            item,
            trackingParams: {
              content_item_id: item.id,
              ...fileParams
            }
          })
          return item
        })
        .catch((error) => {
          dispatch({
            type: CREATE_FILE_CONTENT_ITEM_ERROR,
            fileParams,
            details: error.details
          })
          throw error
        })
    })
  }
}

export function updateContentItem (item) {
  return (dispatch, getState) => {
    const currentItemState = getState().contentItems.data[item.id]
    const availabilityParams = itemsActions.getAvailabilityParams(item)
    const isPublicChanged = currentItemState.is_public !== availabilityParams.is_public

    dispatch({
      type: UPDATE_CONTENT_ITEM,
      item: currentItemState
    })

    return api.updateContentItem({ ...item, ...availabilityParams })
      .then(item => {
        dispatch({
          type: UPDATE_CONTENT_ITEM_SUCCESS,
          item,
          shouldOmitItem: isPublicChanged,
          trackingParams: {
            content_item_id: item.id,
            ...omit(item, 'id')
          }
        })

        return item
      })
  }
}

export function updateFileItem (item) {
  return (dispatch, getState) => {
    return updateContentItem({
      ...item,
      file_name: item.file.name,
      file_id: item.file_id,
      file_meta: item.file_meta
    })(dispatch, getState)
      .then(item => fetchItemUntilImagePresent(item)(dispatch))
  }
}

export function updateFileContentItems (item) {
  return (dispatch, getState) => {
    if (item.item_source === ITEM_SOURCES.file) {
      const uploadPromise = new Promise((resolve) => {
        return resolve(!get(item, 'file.lastModified')
          ? item
          : uploadFile(item.file)
        )
      })

      return uploadPromise.then(result => {
        return updateFileItem({
          ...item,
          file_id: result.file_id,
          storage_provider_id: result.storage_provider_id,
          file_meta: result.file_meta
        })(dispatch, getState)
      })
    } else if (item.item_source === ITEM_SOURCES.box) {
      return updateFileItem({
        ...item
      })(dispatch, getState)
    }
  }
}

export function archiveItem (itemId, makeItemsOffline) {
  return (dispatch, getState) => {
    dispatch({
      type: ARCHIVE_CONTENT_ITEM,
      itemId
    })

    return api.archiveContentItem(itemId, makeItemsOffline)
      .then((item) => {
        dispatch({
          type: ARCHIVE_CONTENT_ITEM_SUCCESS,
          itemId,
          trackingParams: {
            content_item_id: itemId
          }
        })
      })
  }
}

export function unarchiveItem (itemId) {
  return (dispatch, getState) => {
    dispatch({
      type: UNARCHIVE_CONTENT_ITEM,
      itemId
    })

    return api.updateContentItem({ id: itemId, is_archived: false })
      .then((item) => {
        dispatch({
          type: UNARCHIVE_CONTENT_ITEM_SUCCESS,
          itemId,
          trackingParams: {
            content_item_id: itemId
          }
        })
      })
  }
}

export function updateArticleContentItem (itemId, params) {
  return (dispatch, getState) => {
    const currentItemState = getState().contentItems.data[itemId]
    const isDraft = get(params, 'is_draft', currentItemState.is_draft)

    const isDraftChanged = currentItemState.is_draft !== isDraft

    dispatch({
      type: UPDATE_ARTICLE_ITEM,
      contentItemId: itemId,
      item: currentItemState,
      shouldOmitItem: isDraftChanged,
      params
    })
  }
}

export async function fetchDuplicateItems (organizationId, options) {
  return await api.fetchDuplicates(organizationId, options)
}

const initialState = {
  data: {}
}

export function prepareInitialState () {
  return initialState
}

function item (state = {}, action) {
  switch (action.type) {
    case FETCH_CONTENT_ITEM_IMAGE_SUCCESS:
      return {
        ...state,
        image: action.image
      }
    case itemsActions.ADD_CONTENT_ITEM_TO_BOARD:
    case itemsActions.IMPORT_CONTENT_ITEM:
      return {
        ...state,
        boards_used_count: state.boards_used_count + 1,
        board_used: action.board,
        is_imported: true
      }
    case UPDATE_ARTICLE_ITEM:
      return {
        ...state,
        ...action.params
      }
    default:
      return state
  }
}

export default function contentItems (state = initialState, action) {
  switch (action.type) {
    case FETCH_CONTENT_ITEMS_FIRST_PAGE_SUCCESS:
    case FETCH_CONTENT_ITEMS_NEXT_PAGE_SUCCESS:
      return {
        data: {
          ...state.data,
          ...action.data
        }
      }
    case CREATE_FILE_CONTENT_ITEM_SUCCESS:
    case CREATE_CONTENT_ITEM_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          [action.item.id]: action.item
        }
      }
    case FETCH_CONTENT_ITEM_IMAGE_SUCCESS:
    case UPDATE_ARTICLE_ITEM:
    case itemsActions.ADD_CONTENT_ITEM_TO_BOARD:
    case itemsActions.IMPORT_CONTENT_ITEM:
      return {
        ...state,
        data: {
          ...state.data,
          [action.contentItemId]: item(state.data[action.contentItemId], action)
        }
      }
    case ARCHIVE_CONTENT_ITEM_SUCCESS:
    case UNARCHIVE_CONTENT_ITEM_SUCCESS:
      return {
        ...state,
        data: { ...omit(state.data, action.itemId) }
      }
    case UPDATE_CONTENT_ITEM:
    case UPDATE_CONTENT_ITEM_SUCCESS:
      if (action.shouldOmitItem) {
        return {
          ...state,
          data: { ...omit(state.data, action.item.id) }
        }
      } else {
        return {
          ...state,
          data: {
            ...state.data,
            [action.item.id]: action.item
          }
        }
      }
    default:
      return state
  }
}
